import { api } from './server'
import { baseUrl } from '../constants/Connections'

// Identifies this app to the backend, which only redirects back to allowlisted clients.
const SSO_CLIENT = 'teacher'

// Full-page navigation target that starts the provider login.
export function getSSOLoginUrl(provider, loginHint) {
    const params = new URLSearchParams({ client: SSO_CLIENT })
    if (loginHint && loginHint.includes('@')) {
        params.set('login_hint', loginHint.trim())
    }
    return `${baseUrl}/api/auth/sso/${provider}/login?${params.toString()}`
}

// Exchanges the one-time handoff code for the same payload /api/login returns.
export async function exchangeSSOCode(code) {
    return api({ method: 'POST', url: '/api/auth/sso/exchange', data: { code } })
        .then((response) => ({ status: response.status, data: response.data }))
        .catch((error) => ({ status: error?.response?.status, data: error?.response?.data }))
}
